  <label *ngIf="infoMessage.genericInProgress">
    {{infoMessage.genericInProgress}}
  </label>
<label class="SuccessLbl" *ngIf="infoMessage.genericSuccess">{{infoMessage.genericSuccess}} &nbsp;<span class="k-icon k-i-check-circle k-i-checkmark-circle"
      style="color:green;font-weight:600"></span></label>
<label class="errorLbl" *ngIf="infoMessage.genericError">{{infoMessage.genericError}}&nbsp;  <span class="k-icon k-i-cancel" style="color:red;font-weight:300"></span></label>
